let timesliceRecording = {
  initData: null,
  records: []
};

let timesliceExampleRecording = {
  "initData": {
    "width": 414,
    "height": 896,
    "transformCameraMatrix": "simd_float4x4([[0.99125195, -0.037097685, 0.12666215, 0.0], [0.09466183, 0.8685802, -0.48642305, 0.0], [-0.091971084, 0.49415794, 0.86449367, 0.0], [0.003754563, 0.036635026, -0.06760308, 1.0]])",
    "projectionCameraMatrix": "simd_float4x4([[3.309834, 0.0, 0.0, 0.0], [0.0, 1.5293206, 0.0, 0.0], [0.0061804056, -0.02213788, -1.000001, -1.0], [0.0, 0.0, -0.001000001, 0.0]])",
    "backgroundImage": "https://s3.us-west-1.amazonaws.com/statics.vision.remotepc.com/app/timeslice/2020/2/b268392f-8ef1-438a-86dc-a745686a0a9f.jpg",
    "callSid": "90fde53e-86ea-436c-a26e-98a7e8943014",
    "rotation": 90,
    "startedAt": 1582969324289
  },
  "records": [{
    "type": "point",
    "timestamp": 1582969328308,
    "point": "115,405,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328309, "point": "110,408,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328309,
    "point": "110,411,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328310, "point": "110,413,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328310,
    "point": "110,415,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328331, "point": "109,418,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328331,
    "point": "107,421,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328331, "point": "105,425,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328332,
    "point": "102,429,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328332, "point": "100,433,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328332,
    "point": "97,436,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328333, "point": "94,440,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328333,
    "point": "91,445,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328333, "point": "87,450,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328340,
    "point": "71,478,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328405, "point": "100,493,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328436,
    "point": "135,494,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328478, "point": "139,493,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328482,
    "point": "149,491,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328490, "point": "152,490,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328522,
    "point": "160,487,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328540, "point": "163,486,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328568,
    "point": "168,484,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328572, "point": "169,484,414,896", "actor": "user"}, {
    "type": "stopDrawing",
    "timestamp": 1582969328606,
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969329683,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.014712639, -0.054345023, -0.18704425, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969330769,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.0003806227, -0.055914197, -0.18539026, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969332157,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.0, 0.0, 0.0, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969335372,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.019658424, -0.054398667, -0.18669388, 1.0]])",
    "actor": "user"
  }]
}
let timesliceExampleRecording2 = {
  "initData": {
    "width": 414,
    "height": 896,
    "transformCameraMatrix": "simd_float4x4([[0.9942398, -0.04956478, 0.09502721, 0.0], [0.08528298, 0.9028725, -0.4213642, 0.0], [-0.06491264, 0.42704135, 0.901899, 0.0], [0.017109204, 0.07698724, -0.0582856, 1.0]])",
    "projectionCameraMatrix": "simd_float4x4([[3.3136823, 0.0, 0.0, 0.0], [0.0, 1.5310987, 0.0, 0.0], [0.014114976, -0.024116158, -1.000001, -1.0], [0.0, 0.0, -0.001000001, 0.0]])",
    "backgroundImage": "https://s3.us-west-1.amazonaws.com/statics.vision.remotepc.com/app/timeslice/2020/2/1e305cac-726c-4c56-badf-7a27b0f97612.jpg",
    "callSid": "90fde53e-86ea-436c-a26e-98a7e8943014",
    "rotation": 90,
    "startedAt": 1582969361601
  },
  "records": [{
    "type": "point",
    "timestamp": 1582969328308,
    "point": "115,405,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328309, "point": "110,408,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328309,
    "point": "110,411,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328310, "point": "110,413,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328310,
    "point": "110,415,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328331, "point": "109,418,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328331,
    "point": "107,421,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328331, "point": "105,425,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328332,
    "point": "102,429,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328332, "point": "100,433,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328332,
    "point": "97,436,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328333, "point": "94,440,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328333,
    "point": "91,445,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328333, "point": "87,450,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328340,
    "point": "71,478,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328405, "point": "100,493,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328436,
    "point": "135,494,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328478, "point": "139,493,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328482,
    "point": "149,491,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328490, "point": "152,490,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328522,
    "point": "160,487,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328540, "point": "163,486,414,896", "actor": "user"}, {
    "type": "point",
    "timestamp": 1582969328568,
    "point": "168,484,414,896",
    "actor": "user"
  }, {"type": "point", "timestamp": 1582969328572, "point": "169,484,414,896", "actor": "user"}, {
    "type": "stopDrawing",
    "timestamp": 1582969328606,
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969329683,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.014712639, -0.054345023, -0.18704425, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969330769,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.0003806227, -0.055914197, -0.18539026, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969332157,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.0, 0.0, 0.0, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969335372,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.019658424, -0.054398667, -0.18669388, 1.0]])",
    "actor": "user"
  }, {
    "type": "point",
    "timestamp": 1582969369039,
    "point": "C,178,344,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369040,
    "point": "C,167,353,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369042,
    "point": "C,164,358,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369061,
    "point": "C,155,372,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369066,
    "point": "C,154,373,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369074,
    "point": "C,150,382,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369088,
    "point": "C,146,387,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369091,
    "point": "C,144,393,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369104,
    "point": "C,142,399,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369107,
    "point": "C,141,404,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369120,
    "point": "C,140,410,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369123,
    "point": "C,140,415,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369135,
    "point": "C,140,420,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369139,
    "point": "C,140,425,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369152,
    "point": "C,140,429,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369155,
    "point": "C,140,434,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369168,
    "point": "C,142,438,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369171,
    "point": "C,145,443,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369185,
    "point": "C,149,447,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369188,
    "point": "C,153,450,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369202,
    "point": "C,157,453,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369204,
    "point": "C,162,456,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369218,
    "point": "C,166,457,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369220,
    "point": "C,171,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369235,
    "point": "C,175,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369237,
    "point": "C,178,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369252,
    "point": "C,180,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369253,
    "point": "C,183,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369269,
    "point": "C,188,459,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369285,
    "point": "C,189,457,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369286,
    "point": "C,190,456,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369302,
    "point": "C,192,455,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369319,
    "point": "C,193,454,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369338,
    "point": "C,193,453,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369354,
    "point": "C,193,453,351,759",
    "actor": "technician"
  }, {
    "type": "point",
    "timestamp": 1582969369437,
    "point": "C,193,453,351,759",
    "actor": "technician"
  }, {"type": "stopDrawing", "timestamp": 1582969369438, "actor": "technician"}, {
    "type": "arrow",
    "timestamp": 1582969370388,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.008693544, -0.11591692, -0.4545202, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969371106,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.0012553632, -0.20056653, -0.4382472, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969371734,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.13995938, -0.13704418, -0.45886627, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969372842,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.018141773, -0.17814404, -0.44359198, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969373338,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.061443947, -0.25305706, -0.43222037, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969373819,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.09742191, -0.20422646, -0.4537074, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969374188,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.028301923, -0.19213283, -0.4413389, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969375921,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.0, 0.0, 0.0, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969377871,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.06853417, -0.050173998, -0.46290493, 1.0]])",
    "actor": "user"
  }, {
    "type": "arrow",
    "timestamp": 1582969379618,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.0, 0.0, 0.0, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969380589,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.0, 0.0, 0.0, 1.0]])",
    "actor": "technician"
  }, {
    "type": "arrow",
    "timestamp": 1582969381203,
    "arrowMatrix": "simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.107346825, -0.09059355, -0.46645555, 1.0]])",
    "actor": "technician"
  }]
};
const setTimisliceInitData = (recording, timesliceInitData) => {
  recording.initData = timesliceInitData;
};

const addTimesliceRecord = (recording, timesliceRecord) => {
  recording.records.push(timesliceRecord);
};

const printTimesliceRecording = () => {
  console.log(JSON.stringify(timesliceRecording))
};

const createTimesliceRecording = () => {
  return  {
    initData: null,
    records: []
  }
}

export {
  setTimisliceInitData,
  addTimesliceRecord,
  printTimesliceRecording,
  createTimesliceRecording,
  timesliceExampleRecording,
  timesliceExampleRecording2
}
